import { ID_PREFIXES } from './constants';

const isStaffUserId = id => id.startsWith(ID_PREFIXES.STAFF);

export default isStaffUserId;
